import { PreferenceKeys, PreferencesService } from "processes/Preferences";
import { Settings } from 'luxon'

export function initDateTime(preferencesService: PreferencesService) {
    Settings.defaultLocale = preferencesService.get(PreferenceKeys.DEFAULT_LOCALE)
    Settings.defaultZone = preferencesService.get(PreferenceKeys.DEFAULT_TIMEZONE)
}